import React from 'react';
import {Modal, Paper} from "@mui/material";
import Button from "@mui/material/Button";
import {HexColorPicker,HexColorInput} from "react-colorful";

const ColorPicker = ({open, onSubmit, onClose}) => {
    const [color, setColor] = React.useState('#ffffff')

    const submit = () => {
        onSubmit(color);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
        >
            <Paper>
                <HexColorPicker color={color} onChange={setColor} placeholder="Type a color"/>
                <HexColorInput color={color} onChange={setColor}/><br/>
                <Button onClick={submit}>Submit</Button>
            </Paper>
        </Modal>
    );
};

export default ColorPicker;
